// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1GxY5","errors":"Errors_errors__r464Q"};